import { configureStore } from '@reduxjs/toolkit';
import SignInReducer from '../SignIn/Redux/SignInSlice';

const authsStore = configureStore({
    reducer: {
        signIn: SignInReducer
    }
});

export default authsStore;

export type AuthsRootState = ReturnType<typeof authsStore.getState>;
export type AuthsDispatch = typeof authsStore.dispatch;
